import React, {useEffect, useState} from 'react';
import styles from '../../assets/scss/v0/LoveStory.module.scss';
import eventImg1 from '../../assets/images/eventImg1.png';
import useInView from '../custom-hook/useInView';
import flowerLeft from "../../assets/images/v1/wedding-card/flowerLeft1.png";
import flowerRight from "../../assets/images/v1/wedding-card/flowerLeft2.png";

const LoveStory = () => {
    const [animate, setAnimate] = useState(false);

    const [ref, isInView] = useInView({threshold: 0.3});

    useEffect(() => {
        setAnimate(true);
    }, []);

    const eventLst = [
        {
            thumnail: eventImg1,
            desc: '23.09.2017 <br/>',
            subDesc: 'Những rung động đầu tiên',
        },
        {
            thumnail: eventImg1,
            desc: '23.09.2024 <br/>',
            subDesc: 'Hải - Giang quyết định bên nhau trọn đời',
        },
        {
            thumnail: eventImg1,
            desc: '23.03.2025 <br/>',
            subDesc: 'Khởi đầu hành trình bên nhau trọn đời',
        }
    ]

    return (
        <div className={styles.loveStory}
             ref={ref}
        >
            <div className={styles.flowerLeft}>
                <img src={flowerRight} alt={"flowerLeft"}/>
            </div>
            <div className={styles.flowerRight}>
                <img src={flowerRight} alt={"flowerRight"}/>
            </div>
            <div className={styles.title}>Hành Trình Bên Nhau</div>
            <div className={styles.container}>

                {/*<div*/}
                {/*    className={`${styles.event} ${isInView ? styles['animate'] : ''} ${styles.rowReverse}`}*/}
                {/*>*/}

                <div
                    className={`${styles.event} ${isInView ? styles['animate'] : ''} ${styles.rowReverse}`}
                >
                    <img src="https://sit2.bmktech.vn/resources/images/haibv/DSC_0225.JPG" alt={eventLst[0].desc} className={styles.thumnail}/>
                    <div className={styles.descSection}>
                        <div className={styles.desc} dangerouslySetInnerHTML={{__html: eventLst[0].desc}}></div>
                        <div className={styles.subDesc} dangerouslySetInnerHTML={{__html: eventLst[0].subDesc}}></div>
                    </div>
                </div>

                <div
                    className={`${styles.event} ${isInView ? styles['animate'] : ''}`}
                >
                    <img src="https://sit2.bmktech.vn/resources/images/haibv/D0226.jpg" alt={eventLst[1].desc} className={styles.thumnail}/>
                    <div className={styles.descSection}>
                        <div className={styles.desc} dangerouslySetInnerHTML={{__html: eventLst[1].desc}}></div>
                        <div className={styles.subDesc} dangerouslySetInnerHTML={{__html: eventLst[1].subDesc}}></div>
                    </div>
                </div>

                <div
                    className={`${styles.event} ${isInView ? styles['animate'] : ''} ${styles.rowReverse}`}
                >
                    <img src="https://sit2.bmktech.vn/resources/images/haibv/wedding-card-bg.JPG" alt={eventLst[2].desc} className={styles.thumnail}/>
                    <div className={styles.descSection}>
                        <div className={styles.desc} dangerouslySetInnerHTML={{__html: eventLst[2].desc}}></div>
                        <div className={styles.subDesc} dangerouslySetInnerHTML={{__html: eventLst[2].subDesc}}></div>
                    </div>
                </div>



            </div>
        </div>
    );
};

export default LoveStory;